import { TFunction } from 'react-i18next';

export const entityRecordsToOption =
  (t: TFunction) =>
  ({
    id,
    fields,
  }: {
    id: string;
    fields: Record<string, { value: string; name: string }>;
  }) => {
    const { display_name, last_name, first_name, email, name } = Object.values(
      fields
    ).reduce(
      (acc, { name, value }) => {
        if (
          ['display_name', 'last_name', 'first_name', 'email', 'name'].includes(
            name
          )
        ) {
          return {
            ...acc,
            [name]: name === 'email' && value ? ` (${value})` : value,
          };
        }
        return acc;
      },
      {
        display_name: null,
        last_name: null,
        first_name: null,
        email: null,
        name: null,
      }
    );

    return {
      value: id,
      label:
        display_name ||
        [first_name, last_name, email].filter(Boolean).join(' ') ||
        name ||
        t('Unknown'),
    };
  };
